import moment from 'jalali-moment';
import { useState, useCallback, useEffect } from 'react';
import { Input, Col, Rate, Row } from 'antd';
import { Flex, AppButton } from '../../common';
import ReasonItem from './ReasonItem';

export interface SelfRateItemProps {
  item: ReserveVotableEntity;
  reasons: VoteRatingReasonEntity[];
  submit: (id: number, payload: CreateReserveVoteEntity) => Promise<any>;
}


const reasonLables = [
  'کیفیت غذا',
  'کمیت و حجم غذا',
  'رعایت اصول بهداشتی',
  'تجهیزات رستوران',
  'رفتار مناسب پرسنل ',
  'منوی غذایی'
]

export function SelfRateItem({
  item,
  reasons = [],
  submit,
}: SelfRateItemProps) {

  const [score, setScore] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [reasonIds, setReasonIds] = useState([]);

  const date = moment.from(item.program.date, 'en', 'YYYY-MM-DD');

  const handleSubmitVote = useCallback(async (id: number) => {
    await submit(id, { score, description, problemIds: reasonIds });
    setOpen(false);
    setScore(0);
  }, [score, description, reasonIds]);

  const handleRateChange = useCallback((value: number) => {
    setScore(value);
    if (value > 0) {
      setOpen(true);
    }
    else {
      setOpen(false);
      setDescription('');
      setReasonIds([]);
    }
  }, []);

  const handleReasonClick = useCallback((reasonId: number) => {
    setReasonIds(items => {
      // Check if the reason is already selected
      if (items.includes(reasonId)) {
        // If already selected, remove it
        const newItems = items.filter(id => id !== reasonId);
       
        return newItems;
      } else {
        // If not selected, add it
        const newItems = [...items, reasonId];
        
        return newItems;
      }
    });
  }, []);


  const renderButton = useCallback(({ span, lg, className = '' }) => {
    return score > 0 && (
      <Col className={className} span={span} lg={lg}>
        <AppButton
          type="primary"
          appVariant="nurture"
          className="w-full"
          onClick={handleSubmitVote.bind({}, item.id)}>
          ارسال دیدگاه
        </AppButton>
      </Col>
    );
  }, [score, item, handleSubmitVote]);

  useEffect(() => {
    setReasonIds([]);
  }, [score]);

  const positiveReasons = reasons.filter(x => x.type === 'positive')
  const negativeReasons = reasons.filter(x => x.type === 'negative')



  const allReasons = reasonLables.map((item, index) => ({
    description: item,
    positive: positiveReasons[index],
    negative: negativeReasons[index]
  }))

  return (
    <Flex direction="column" className="bg-app-gray-extra-light p-2 rounded-lg">
      <Row>
        <Col span={10} lg={4} className="!inline-flex !text-primary font-bold">
          {item?.program?.mealType?.name}
        </Col>
        <Col span={12} lg={0} className="!text-app-gray-darker !inline-flex lg:!hidden justify text-end text-xs ms-auto">
          <span className="ms-auto">{date.format('dddd DD MMMM')}</span>
        </Col>
        <Col span={24} lg={13} className="!text-primary font-bold !mt-2 lg:!mt-0">
          {item?.program?.self?.name}
        </Col>
        <Col span={0} lg={7} className="!text-app-gray-darker !hidden lg:!inline-flex justify-end">
          {date.format('dddd DD MMMM jYYYY')}
        </Col>
      </Row>
      <span className="py-2">
        {item?.program?.foods.map(food => food.name).join(' | ')}
      </span>
      <Flex align="center">
        <Rate value={score} onChange={handleRateChange} />
        {renderButton({ span: 0, lg: 5, className: 'mt-auto ms-auto' })}
      </Flex>
      <Row className="flex !basis-0" gutter={[8, 8]}>
        {isOpen && (
          <Col span={24} lg={12}>
            <Row className="flex flex-row" gutter={[8, 8]}>
              {allReasons.map((reason, index) => (
                <ReasonItem
                  key={item.program.id + '-' + index}
                  desc={reason.description}
                  positiveId={reason.positive.id}
                  negativeId={reason.negative.id}
                  checkedIds={reasonIds}
                  onClick={handleReasonClick}
                />
              ))}
            </Row>
          </Col>
        )}
        {isOpen && score > 0 && (
          <>
            <Col className="!h-auto lg:!h-full pb-5" span={24} lg={12}>
              <Input.TextArea
                placeholder="افزودن نظر ..."
                className="!h-[120px] lg:!h-full"
                value={description}
                showCount
                maxLength={250}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Col>
          </>
        )}
        {renderButton({ span: 24, lg: 0, className: 'w-full' })}
      </Row>
    </Flex>
  );
};

export default SelfRateItem;
